<div class="modal-header">
  <h5 class="modal-title" id="myModalLabel">{{ title | translate }}</h5>
  <button
    type="button"
    class="btn-close"
    data-bs-dismiss="modal"
    aria-label="Close"
    (click)="onClose('cancel')"
  ></button>
</div>
<div class="modal-body">
  <h5 class="font-size-16" *ngIf="!message">{{ 'confirmDelete.value' | translate }}</h5>
  <h5 class="font-size-16" *ngIf="message">{{ message | translate }}</h5>
  <span *ngIf="FieldName">{{ FieldName | translate }}</span>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="onClose('cancel')">
    {{ 'close.value' | translate }}
  </button>
  <button type="button" class="btn btn-primary" (click)="onClose('confirm')">
    {{ 'confirm.value' | translate }}
  </button>
</div>
